<template>
  <div>
    <div class="d-flex">
      <nav id="breadcrumbs" class="mb-3">
        <ul>
          <li>
            <router-link :to="{ name: 'company.dashboard' }">
              <a href="#"> <i class="uil-home-alt"></i> </a>
            </router-link>
          </li>
          <li>
            <span> {{
                this.$t('report.company_dashboard.reports')
              }}
            </span>
          </li>
          <li>{{ this.$t('general.exam_detailed_report') }}</li>
        </ul>
      </nav>
    </div>

    <div class="section-header mb-lg-2 border-0 uk-flex-middle">
      <div class="section-header-left">
        <h2 class="uk-heading-line text-left">
          <span> {{ this.$t('general.exam_detailed_report') }} </span>
        </h2>
      </div>
    </div>
    <!--Modal Profie-->
    <div v-if="error" class="uk-alert-danger mb-3" uk-alert>
      <a class="uk-alert-close" uk-close></a>
      <p style="color:red;">
        <i class="uil-exclamation-triangle"></i> {{ error }}
      </p>
    </div>
    <!--End Modal Profile -->
    <div class="card">
      <!-- Card header -->
      <div class="card-header actions-toolbar border-0 d-flex">
        <!-- <div>
          <a aria-expanded="false" class="btn btn-icon btn-hover btn-circle" href="javascript:void(0)">
            <i class="uil-search"></i>
          </a>
          <div class="uk-drop" style="left: 91px; top: 159.297px;"
               uk-drop="mode: hover; pos: right-center; offset: 0">
              <span class="uk-search uk-search-navbar uk-width-1-1">
                <input v-model="filter.search" :placeholder="$t('general.searchByExam')" autofocus=""
                       class="uk-search-input shadow-0 uk-form-small" type="search">
              </span>
          </div>
        </div> -->
        <div class="row" style="width:100%">
          <div class=" col-md-1  search-icon ">
            <i class="uil-search"></i>
          </div>
          <div class="col-md-11 uk-search uk-search-navbar" style="margin-left:-2rem">
            <input v-model="filter.search" :placeholder="$t('general.searchByExam')" autofocus=""
                   class="uk-search-input shadow-0 uk-form-small" type="search"/>
          </div>
        </div>
        <!-- <h4 class="d-inline-block mb-0"></h4> -->
        <div class="d-flex">
          <a :uk-tooltip="$t('filters.order.sort')" aria-expanded="false" class="btn btn-icon btn-hover  btn-circle"
             href="javascript:void(0)" title="">
            <i class="uil-list-ui-alt"></i>
          </a>
          <div class="uk-dropdown" uk-dropdown="pos: bottom-right ; mode: click ;animation: uk-animation-scale-up">
            <ul class="uk-nav uk-dropdown-nav">
              <li class="uk-active">
                <a href="javascript:void(0)" @click="sortOrder('asc', 'name')">{{ $t("sorting.a_z") }}</a>
              </li>
              <li>
                <a href="javascript:void(0)" @click="sortOrder('desc', 'name')">{{ $t("sorting.z_a") }}</a>
              </li>
            </ul>
          </div>
          <!-- Filter -->
          <filter-dropdown-button @reset="resetFilter" @filter="filterResult">
            <div class="uk-child-width-1-2@s uk-grid-small" uk-grid>
              <app-multiselect v-model="assignment_id" :allow-empty="true" :is-multiple="true"
                               :options="assignmentLoading ? [] : assignmentList"
                               :placeholder="assignmentLoading ? $t('general.loading') + '...' : $t('exam.choose_education')"
                               :title="$t('education.education')"
                               label="name"
                               track-by="id" @input="getExams"/>

              <app-multiselect v-model="exam_id" :allow-empty="true" :is-multiple="true"
                               :options="examLoading ? [] : examList"
                               :placeholder="examLoading ? $t('general.loading') + '...' : $t('exam.exam_choose')"
                               :title="$t('exam.exam')"
                               label="name"/>
            </div>
          </filter-dropdown-button>

          <excel-download-button
              :loading="isReportDownloading"
              :tooltipText="$t('filters.export_excell')"
              @download="exportExamExcelResults"
          />

        </div>
      </div>
      <!-- Table -->
      <default-loading v-if="tableLoading"></default-loading>
      <template v-else>
        <div class="table-responsive">
          <table class="table align-items-center">
            <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">{{ $t('general.first_name_and_last_name') }}</th>
              <th scope="col">{{ $t('general.assignment_name') }}</th>
              <th scope="col">{{ $t("users.user_email") }}</th>
              <th scope="col">{{ $t('general.exam_name') }}</th>
              <th scope="col">{{ $t('general.score') }}</th>
              <th scope="col">{{ $t('general.created_at') }}</th>
              <th scope="col">{{ $t('general.start_date') }}</th>
              <th scope="col">{{ $t('ajadam.end_date') }}</th>
              <th scope="col">{{ $t('general.average_grade') }}</th>
              <th scope="col">{{ $t('general.correct_answer_rate') }}</th>
              <th scope="col">{{ $t('general.wrong_answer_rate') }}</th>
              <th scope="col">{{ $t('general.passing_grade') }}</th>
            </tr>
            </thead>
            <tbody class="list">
            <template v-for="item in formattedItems">
              <tr>
                <td class="detail-button">
                  <button
                      :uk-tooltip="$t('general.detail')"
                      class="btn btn-sm btn-detail"
                      @click="showExamDetails(item)"
                  >
                    <i class="uil-clipboard-notes"></i>
                    <span class="btn-text">{{ $t('general.detail') }}</span>
                  </button>
                </td>
                <td>{{ item.firstname }} {{ item.surname }}</td>
                <td>{{ item.assignmentName }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.examName }}</td>
                <td>{{ item.point.toFixed(2) }}</td>
                <td>{{ item.examCreatedAt }}</td>
                <td>{{ item.startDate }}</td>
                <td>{{ item.endDate }}</td>
                <td>{{ typeof item.exam_avarage === 'number' ? item.exam_avarage.toFixed(2) : item.exam_avarage }}</td>
                <td>{{ item.exam_right_answer_avarage }}</td>
                <td>{{ item.exam_wrong_answer_avarage }}</td>
                <td>{{ item.passmark }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <pagination :pagination="pagination" class="mt-2 mb-3" @changePage="setPage($event)"></pagination>
      </template>
    </div>

    <!-- Exam Details Modal -->
    <div id="examDetailsModal" class="uk-modal" uk-modal>
      <div class="uk-modal-dialog">
        <div class="modal-header">
          <h2 class="uk-modal-title">{{ $t('general.exam_detail') }}</h2>
          <button class="uk-modal-close-default" type="button" uk-close></button>
        </div>

        <div class="uk-modal-body">
          <div v-if="selectedExam" class="exam-details">
            <div class="exam-info">
              <div class="info-row">
                <span class="info-label">{{ $t('exam.name') }}</span>
                <span class="info-value">{{ selectedExam.examName }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('general.name') }}</span>
                <span class="info-value">{{ selectedExam.userName }} {{ selectedExam.userSurname }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('general.score') }}</span>
                <div class="info-value">
                  <div class="score-container">
                    <div class="score-bar">
                      <div
                          :style="{width: selectedExam.point + '%', backgroundColor: selectedExam.point >= selectedExam.passmark ? '#28a745' : '#dc3545'}"
                          class="score-bar-fill"></div>
                    </div>
                    <span class="score-value">{{ selectedExam.point }}%</span>
                  </div>
                </div>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('general.start_date') }}</span>
                <span class="info-value">{{ selectedExam.startDate }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">{{ $t('general.end_date') }}</span>
                <span class="info-value">{{ selectedExam.endDate }}</span>
              </div>
            </div>

            <div class="questions-list">
              <h3 class="section-title">{{ $t('general.user_answers') }}</h3>
              <div v-for="(question, index) in selectedExam.question_details"
                   :key="question.question_id"
                   class="question-item">
                <div class="question-content">
                  <span class="question-number">{{ index + 1 }}.</span>
                  <div class="question-text" v-html="question.text"></div>
                </div>
                <div class="question-content">
                  <div class="answer-text" :class="question.is_correct?'green-text':'red-text'" >{{$t('general.given_answer')}}: {{question.option_text }}</div>
                </div>
                <div class="question-status">
                  <span v-if="question.is_correct"
                        class="status-badge status-badge-success">
                    <i class="uil-check"></i>
                    <span>{{ $t('question.attributes.true') }}</span>
                  </span>
                  <span v-else
                        class="status-badge status-badge-danger">
                    <i class="uil-times"></i>
                    <span>{{ $t('question.attributes.false') }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reports, { ERROR, GET_ITEMS, ITEMS, LOADING, MODULE_NAME, SUCCESS, } from "@/core/services/store/reports.module";
import store from "@/core/services";
import moment from "moment";
import axios from "axios";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import Pagination from "@/assets/components/Pagination";
import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import FilterDropdownButton from "@/view/components/filter/FilterDropdownButton.vue";
import ExcelDownloadButton from "@/view/components/buttons/ExcelDownloadButton.vue";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "ReportExamResults",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, reports);
  },
  components: {
    ExcelDownloadButton,
    DefaultLoading, Pagination, AppMultiselect, FilterDropdownButton
  },
  data() {
    return {
      pagination: null,
      exam_id: null,
      assignment_id: null,
      page: 1,
      per_page: 10,
      formattedItems: [],
      examList: [],
      assignmentList: [],
      examLoading: false,
      assignmentLoading: false,
      tableLoading: false,
      error: null,
      filter: {
        search: null,
        order: "desc",
        sort: "name",
      },
      selectedExam: null,
      isReportDownloading: false
    };
  },
  computed: {
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
  },
  methods: {
    timeFromDate(value) {
      const m = moment.utc(value, 'YYYY-MM-DD HH:mm:ss', true);
      return m.isValid() ? m.local().locale(this.secureLocalStorage("language")).format('DD/MM/YYYY HH:mm:ss') : '-';
    },
    exportExamExcelResults() {
      if (this.isReportDownloading) {
        return;
      }
      this.isReportDownloading = true;

      const exam_ids = this.exam_id?.map(exam => exam.id) || []
      const assignment_ids = this.assignment_id?.map(exam => exam.id) ||[]

      const params = {
        exam_id: JSON.stringify(exam_ids),
        assignment_id: JSON.stringify(assignment_ids),
        sort: this.filter.sort,
        order: this.filter.order,
        like: this.filter.search,
        report: Math.random() * 9999999
      }

      axios.get(process.env.VUE_APP_BACKEND_APP_URL + "/api/report/export/exam-results",
          {
            responseType: "blob",
            params,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.secureLocalStorage("token"),
            },
          }
      )
          .then((response) => {
            let fileURL = window.URL.createObjectURL(new Blob([response.data]));
            let fileLink = document.createElement("a");
            fileLink.href = fileURL;
            let day = moment().format("YYYYMMDDHHMMSS");
            let fileName = "exam_result_report_list_" + day + ".xlsx";
            fileLink.setAttribute("download", fileName);
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL);

            this.isReportDownloading = false;
          })
          .catch(() => {
            this.isReportDownloading = false;
          });
    },
    resetFilter() {
      this.assignment_id = null;
      this.exam_id = null;
      this.examList = [];
      this.examLoading = false;
      this.assignmentLoading = false;
      this.tableLoading = false;
     },
    checkInitialState() {
      if (!this.exam_id || this.exam_id.length === 0) {
        this.error = this.$t('general.choose_education_info');
      }
    },
    filterResult(filter = null) {
      let self = this;
      this.error = null;
      this.tableLoading = true;

      if (!self.exam_id || self.exam_id.length === 0) {
        this.error = this.$t('general.choose_education_info');
        this.tableLoading = false;
        this.formattedItems =[]
        return false;
      }

      const exam_ids = this.exam_id?.map(exam => exam.id) || []
      const assignment_ids = this.assignment_id?.map(exam => exam.id) || []

      let filters = {
        like: self.filter.search,
        page: self.page,
        per_page: self.per_page,
        sort: self.filter.sort,
        order: self.filter.order,
        exam_id: JSON.stringify(exam_ids),
        assignment_id: JSON.stringify(assignment_ids),
      };

      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/report/exam-results",
            filters: filters,
          })
          .then((response) => {
            this.tableLoading = false;
            if (response.status) {
              let results = [];
              this.pagination = response.data.results;
              let items = response.data.results.data;
              let exams = response.data.exams || [];

              items.forEach((item) => {
                // İlgili sınavın genel istatistikleri
                const examStats = exams.find(e => e.id === item.exam_id) || {};

                // Kullanıcının sınava başlama tarihi kontrolü - note: sınava başlama tarihi verisi yok
                const hasUserStartedExam = item.start_date && item.end_date;

                // Ortalama değerleri hesapla
                let examAverage = null;
                let rightAnswerAverage = "-";
                let wrongAnswerAverage = "-";

                if (hasUserStartedExam && examStats.user_results_count > 0) {
                  // Sınav ortalaması
                  examAverage = examStats.user_results_sum_point / examStats.user_results_count;

                  // Doğru cevap yüzdesi
                  const rightAnswerPercent = ((examStats.user_results_sum_right_answer_count /
                      (examStats.questions_count * examStats.user_results_count)) * 100).toFixed(2);
                  rightAnswerAverage = `${examStats.user_results_sum_right_answer_count} - ${rightAnswerPercent}%`;

                  // Yanlış cevap yüzdesi
                  const wrongAnswerPercent = ((examStats.user_results_sum_wrong_answer_count /
                      (examStats.questions_count * examStats.user_results_count)) * 100).toFixed(2);
                  wrongAnswerAverage = `${examStats.user_results_sum_wrong_answer_count} - ${wrongAnswerPercent}%`;
                }

                results.push({
                  ...item,
                  examName: item.examName || "-",
                  assignmentName: item.assignmentName || "-",
                  firstname: item.userName || "-",
                  surname: item.userSurname || "-",
                  examCreatedAt: item.examCreatedAt ? moment(item.examCreatedAt).format("DD/MM/YYYY HH:mm") : "-",
                  startDate: item.start_date ? this.timeFromDate(item.start_date) : "-",
                  endDate: item.end_date ? this.timeFromDate(item.end_date) : "-",        
                  point: item.point || 0,
                  exam_avarage: examAverage !== null ? examAverage : "-",
                  exam_right_answer_avarage: rightAnswerAverage,
                  exam_wrong_answer_avarage: wrongAnswerAverage,
                  passmark: item.passmark || 0,
                  question_details: item.question_details || []
                });
              });

              this.formattedItems = results;
            }
          })
          .catch(error => {
            this.tableLoading = false;
            console.error('Filter error:', error);
            this.error = this.$t('general.error_occurred');
          });
    },
    setPage(page) {
      this.page = page;
      this.filterResult();
    },
    getAssignments() {
      this.assignmentLoading = true;
      let filters = {
        page: 0,
        order: "id",
        sort: "desc",
        content_file_category_id: 12
      };

      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/assignment",
            filters: filters,
          })
          .then((response) => {
            this.assignmentLoading = false;
            if (response.status) {
              let results = [];
              let items = response.data;
              items.forEach((item) => {
                results.push({
                  id: item.id,
                  name: item.full_name,
                  order_number: item.order_number,
                });
              });
              this.assignmentList = results;
            }
          })
          .catch(() => {
            this.assignmentLoading = false;
          });
    },
    getExams(exams) {
      const assignment_ids = exams.map(exam => exam.id) ||[]
      this.examLoading = true;

      let filters = {
        per_page: 0,
        sort: "id",
        order: "desc",
        fields: "id,name",
        assignment_id: JSON.stringify(assignment_ids),
      };

      this.exam_id = null
      this.examList = []

      store
          .dispatch(_MODULE_NAME + "/" + GET_ITEMS, {
            url: "api/exam",
            filters: filters,
          })
          .then((response) => {
            this.examLoading = false;
            if (response.status) {
              let results = [];
              let items = response.data;
              items.forEach((item) => {
                results.push({
                  id: item.id,
                  name: item.name,
                });
              });
              this.examList = results;
            }
          })
          .catch(() => {
            this.examLoading = false;
          });
    },
    sortOrder(order, sort) {
      this.page = 1;
      this.filter.order = order;
      this.filter.sort = sort;

      this.filterResult();
    },

    showExamDetails(exam) {
      this.selectedExam = exam;
      UIkit.modal('#examDetailsModal').show();
    },
  },
  mounted() {
    this.getAssignments();
    this.checkInitialState();
    this.debouncedFilterSearch = _.debounce(this.filterResult, 500);
  },
  watch: {
    success: function (val) {
      if (val) {
        this.filterResult();
      }
    },
    "filter.search": function (val) {
      this.debouncedFilterSearch();
    },
  },
};
</script>

<style scoped>
/* Modal Styles */
.uk-modal-dialog {
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  max-width: 700px !important;
  width: 90%;
  margin: 30px auto;
}

.modal-header {
  padding: 0.875rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header .uk-modal-title {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #3e416d;
  margin: 0;
}

.uk-modal-close-default {
  padding: 0.375rem;
  color: #6c757d;
  opacity: 0.7;
  transition: opacity 0.15s ease;
}

.uk-modal-body {
  padding: 1rem;
  background-color: #fff;
}

/* Exam Details Content */
.exam-details {
  max-height: calc(90vh - 140px);
  overflow-y: auto;
}

.exam-info {
  margin-bottom: 1.25rem;
  padding: 0.875rem;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
}

.exam-info .info-row {
  display: flex;
  margin-bottom: 0.625rem;
  font-size: 0.875rem;
}

.exam-info .info-row:last-child {
  margin-bottom: 0;
}

.exam-info .info-label {
  width: 150px;
  color: #6c757d;
  flex-shrink: 0;
  padding-right: .5rem;
}

.exam-info .info-value {
  flex: 1;
  color: #3e416d;
}

.exam-info .score-container {
  display: flex;
  align-items: center;
  gap: 0.625rem;
}

.exam-info .score-bar {
  flex: 1;
  height: 3px;
  background-color: #f0f0f0;
  border-radius: 1px;
  overflow: hidden;
}

.exam-info .score-bar-fill {
  height: 100%;
  background-color: #3e416d;
  transition: width 0.2s ease;
}

.exam-info .score-value {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #3e416d;
  min-width: 2.5rem;
  text-align: right;
}

/* Questions List */
.questions-list {
  margin-top: 1.25rem;
}

.questions-list .section-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #3e416d;
  margin-bottom: 0.875rem;
  padding-bottom: 0.375rem;
  border-bottom: 1px solid #f0f0f0;
}

.question-item {
  padding: 0.875rem;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  margin-bottom: 0.625rem;
  background-color: #fff;
}

.question-item:last-child {
  margin-bottom: 0;
}

.question-content {
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
}

.question-number {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #3e416d;
  min-width: 1.25rem;
}

.question-text {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #3e416d;
}

.answer-text {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #3e416d;
  margin-top: 8px;
  font-weight: bold;
}

.green-text {
  color: #0fa704;
}

.red-text {
  color: #d30b0b;
}

.question-text :deep(p) {
  margin: 0;
  font-size: 0.875rem;
}

.question-status {
  margin-top: 0.625rem;
  display: flex;
  justify-content: flex-end;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.1875rem 0.375rem;
  font-size: 0.75rem;
  border-radius: 2px;
  border: 1px solid transparent;
}

.status-badge i {
  margin-right: 0.1875rem;
  font-size: 0.8125rem;
}

.status-badge-success {
  background-color: rgba(40, 167, 69, 0.06);
  color: #2a9d4f;
  border-color: rgba(40, 167, 69, 0.08);
}

.status-badge-danger {
  background-color: rgba(220, 53, 69, 0.06);
  color: #c82333;
  border-color: rgba(220, 53, 69, 0.08);
}

/* Scrollbar */
.exam-details::-webkit-scrollbar {
  width: 2px;
}

.exam-details::-webkit-scrollbar-track {
  background: #fafafa;
}

.exam-details::-webkit-scrollbar-thumb {
  background: #e0e0e0;
  border-radius: 1px;
}

.exam-details::-webkit-scrollbar-thumb:hover {
  background: #d0d0d0;
}

/* Detay Butonu Stilleri */
.detail-button .btn-detail {
  min-width: 100px;
  height: 32px;
  padding: 0 0.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 4px;
  background-color: #f5f8fa;
  border: 1px solid #e4e6ef;
  transition: all 0.2s ease;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  color: #3e416d;
}

.detail-button .btn-detail i {
  font-size: 1rem;
  color: #3e416d;
  transition: all 0.2s ease;
}

.detail-button .btn-detail .btn-text {
  display: inline-block;
  transition: all 0.2s ease;
}

.detail-button .btn-detail:hover {
  background-color: #e1f0ff;
  border-color: #e1f0ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.detail-button .btn-detail:hover i,
.detail-button .btn-detail:hover .btn-text {
  color: #3699ff;
}

.detail-button .btn-detail:active {
  transform: translateY(0);
  box-shadow: none;
}

/* Responsive Tasarım */
@media (max-width: 768px) {
  .detail-button .btn-detail {
    min-width: 32px;
    padding: 0;
  }

  .detail-button .btn-detail .btn-text {
    display: none;
  }

  .detail-button .btn-detail i {
    margin: 0;
  }
}

/* Tooltip Stilleri */
[uk-tooltip] {
  cursor: pointer;
}

[uk-tooltip]:before {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
  border-radius: 3px;
  background-color: #3e416d;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}
</style>

<style>
.multiselect__tag {
  color: white;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background-color: #3e416d;
}

.multiselect__tag-icon {
  background-color: transparent;
  line-height: 2.2;
}

.multiselect__tag-icon:after {
  color: #fff;
}

.multiselect__tag-icon:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.multiselect__input {
  border: unset !important;
}

.multiselect__tags .multiselect__input {
  border: unset !important;
}
</style>
